import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetUserSessionQuery } from '../../services/api/userApi';

const withAuthProtection = (WrappedComponent, requireSubscription = false) => {
  const ProtectedRoute = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { data: userSessionData, isLoading: isUserSessionLoading, isError: isUserSessionError, isFetching: isUserSessionFetching } = useGetUserSessionQuery();

    const loggedIn = userSessionData?.isLoggedIn;
    const isSubscribed = userSessionData?.isSubActive?.isActive;
    
    React.useEffect(() => {
      if (!loggedIn && !isUserSessionError && !isUserSessionFetching && !isUserSessionLoading && userSessionData) {
        // Store the attempted URL for redirect after login
        navigate('/signin', { 
          state: { from: location.pathname },
          replace: true 
        });
        return;
      }

      if (requireSubscription && !isSubscribed) {
        navigate('/pricing', { replace: true });
        return;
      }
    }, [loggedIn, isSubscribed, navigate, location, userSessionData, isUserSessionError]);

    // Show nothing while checking auth status
    if (!loggedIn || (requireSubscription && !isSubscribed) && !isUserSessionFetching && !isUserSessionLoading) {
      return null;
    }

    // Render the protected component if authenticated
    return <WrappedComponent {...props} />;
  };

  // Set display name for debugging
  ProtectedRoute.displayName = `withAuthProtection(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  
  return ProtectedRoute;
};

export default withAuthProtection;
